import { render, staticRenderFns } from "./Evidences.vue?vue&type=template&id=dc6ebc4e"
import script from "./Evidences.vue?vue&type=script&lang=ts"
export * from "./Evidences.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports